<!-- Ported from the Polaris kit: src/components/ui/attachment/AttachmentAction.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';
import Button from '../button/Button.vue';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  variant: { type: null, required: false, default: 'ghost' },
  size: { type: null, required: false, default: 'icon-xs' },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
});
</script>

<template>
  <Button
    data-slot="attachment-action"
    :variant="variant"
    :size="size"
    :class="cn(props.class)"
  >
    <slot />
  </Button>
</template>
